import { memo, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputLabel,
  TextField,
} from '@mui/material';
import { CloseIcon } from '~/assets/icons';
import { useTranslation } from 'react-i18next';

type SaveAsTemplateProps = {
  form: any;
  open: boolean;
  setSaveAsTemplate: (onSave: boolean) => void;
  setOpen: (open: boolean) => void;
  handleDataReturn?: (name: string) => void;
};

function SaveAsTemplateDialog(props: SaveAsTemplateProps) {
  const { t } = useTranslation(['admin/job', 'admin/common']);
  const { form } = props;

  const [name, setName] = useState<string>('');
  const handleSetOpen = (open: boolean) => {
    if (props.setOpen) {
      props.setOpen(open);
    }
  };

  const handleSubmit = () => {
    props.setSaveAsTemplate(true);
    props.handleDataReturn && props.handleDataReturn(name ?? '');
  };
  const handleCancel = () => {
    props.setOpen(false);
  };

  useEffect(() => {
    if (form.values.name) {
      setName(form.values.name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);
  return (
    <Dialog open={props.open} onClose={() => handleSetOpen(false)} fullWidth maxWidth='md'>
      <DialogTitle>
        {t('saveAsNewTemplate', { ns: 'admin/common' })}
        <IconButton onClick={() => handleSetOpen(false)} className='absolute right-[10px] top-[10px]'>
          <CloseIcon className='w-[10px] h-[10px]' />
        </IconButton>
      </DialogTitle>

      <DialogContent className='p-0'>
        <Box>
          <Box className='mt-3 w-full'>
            <InputLabel className='content-center	'> {t('estimateTemplate.name')}</InputLabel>
            <TextField
              name={`name`}
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              error={form.errors.name}
              helperText={form.errors.name}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button color='secondary' variant='contained' onClick={() => handleCancel()}>
          {t('cancel', { ns: 'admin/common' })}
        </Button>
        <Button color='primary' variant='contained' onClick={() => handleSubmit()}>
          {t('save', { ns: 'admin/common' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(SaveAsTemplateDialog);
